/* Reveliane – bloco de oferta: a opcao escolhida (1x ou 1+1) define a quantidade do formulario de compra. */
(function () {
  'use strict';
  if (window.RevelianeDeal) return;
  function aplica(deal, radio) {
    deal.querySelectorAll('.rv-deal__bar').forEach(function (b) { b.classList.toggle('is-selected', b.contains(radio)); });
    var form = document.getElementById(deal.getAttribute('data-form'));
    var inputs = [];
    if (form) {
      inputs = Array.prototype.slice.call(form.querySelectorAll('input[name="quantity"]'));
      inputs = inputs.concat(Array.prototype.slice.call(document.querySelectorAll('input[name="quantity"][form="' + form.id + '"]')));
    }
    inputs = inputs.concat(Array.prototype.slice.call(deal.querySelectorAll('[data-reveliane-qty]')));
    inputs.forEach(function (i) { i.value = radio.value; });
    /* quantity-input do Dawn (pagina de produto), se existir */
    if (form) {
      var qi = document.querySelector('quantity-input input[form="' + form.id + '"]');
      if (qi) { qi.value = radio.value; qi.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    deal.dispatchEvent(new CustomEvent('reveliane:deal', { detail: { quantity: radio.value }, bubbles: true }));
  }
  document.addEventListener('change', function (e) {
    var radio = e.target.closest && e.target.closest('[data-reveliane-deal] input[type="radio"]');
    if (radio) aplica(radio.closest('[data-reveliane-deal]'), radio);
  });
  function init() {
    document.querySelectorAll('[data-reveliane-deal]').forEach(function (deal) {
      var r = deal.querySelector('input[type="radio"]:checked');
      if (r) aplica(deal, r);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  window.RevelianeDeal = { init: init };
})();
